var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-speed-dial',{staticClass:"md-top-right",attrs:{"md-direction":"bottom"}},[_c('md-speed-dial-target',{staticClass:"uLarge md-round md-just-icon md-info",on:{"click":_vm.add}},[_c('md-icon',[_vm._v("add")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }